import {
  ArrowLeftOutlined,
  CheckCircleOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Button, Divider, Form, Input } from "antd";
import { useForm } from "antd/es/form/Form";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ruleRequired } from "../../constants/rules/RulesConstantsForms";
import { ruleAddress } from "../../constants/rules/RulesConstantsUser";
import { IField } from "../../interfaces/IField";
import { useEditClientMutation } from "../../store/api/listClient.api";
import { useAppSelector } from "../../store/reduxHooks";
import {
  SELECT_CLIENT,
  SELECT_CLIENT_FROM_INITIAL,
} from "../../store/selectors/listClientSelector";

import classes from "./PageClient.module.css";

export function PageClient(): ReactElement {
  const [isEditForm, setStateForm] = useState(false);

  const [eioInfoForm] = useForm();
  const [contactInfoForm] = useForm();
  const [reportInfoForm] = useForm();

  const initialData = useAppSelector(SELECT_CLIENT_FROM_INITIAL);
  const selectedClient = useAppSelector(SELECT_CLIENT);
  const [editClient] = useEditClientMutation();
  const navigate = useNavigate();

  const resetForms = () => {
    eioInfoForm.resetFields();
    contactInfoForm.resetFields();
    reportInfoForm.resetFields();
  };

  const setInitialValues = () => {
    eioInfoForm.setFieldsValue(initialData);
    contactInfoForm.setFieldsValue(initialData);
    reportInfoForm.setFieldsValue(initialData);
  };

  useEffect(() => {
    setInitialValues();
    return () => resetForms();
  }, [initialData, isEditForm, eioInfoForm, contactInfoForm, reportInfoForm]);

  const sendDate = () => {
    const user = {
      id: selectedClient.id ? selectedClient.id : 0,
      surname: contactInfoForm.getFieldInstance("surname"),
      name: contactInfoForm.getFieldInstance("name"),
      patronymic: contactInfoForm.getFieldInstance("patronymic"),
      email: contactInfoForm.getFieldInstance("email"),
      inn: contactInfoForm.getFieldInstance("inn"),
      phone_number: contactInfoForm.getFieldInstance("phone_number"),
    };
    const organization = {
      inn: contactInfoForm.getFieldInstance("organization_inn"),
      ogrn: contactInfoForm.getFieldInstance("organization_ogrn"),
      name: contactInfoForm.getFieldInstance("organization_name"),
      phone_number: contactInfoForm.getFieldInstance(
        "organization_phone_number",
      ),
      email: contactInfoForm.getFieldInstance("organization_email"),
    };

    const cleanedUsers = Object.fromEntries(
      Object.entries(user).filter(([, value]) => value),
    );

    const cleanedOrganization = organization
      ? Object.fromEntries(
          Object.entries(organization).filter(([, value]) => value),
        )
      : null;

    if (initialData?.id) {
      editClient({ user: cleanedUsers, organization: cleanedOrganization });
    }
    setStateForm(true);
  };

  const clientEioInfo: IField[] = [
    {
      id: "1",
      label: <span className={classes.formItemLabel}>Фамилия</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.surname}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "2",
      label: <span className={classes.formItemLabel}>Имя</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.name}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },

    {
      id: "3",
      label: <span className={classes.formItemLabel}>Отчество</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.patronymic}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "4",
      label: <span className={classes.formItemLabel}>ИНН</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.inn}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "5",
      label: (
        <span className={classes.formItemLabel}>
          Почтовый адрес пользователя
        </span>
      ),
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.email}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "6",
      label: <span className={classes.formItemLabel}>Телефон</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.phone_number}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "7",
      label: (
        <span className={classes.formItemLabel}>Наименование организации</span>
      ),
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {initialData?.organization_name}
        </div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "8",
      label: <span className={classes.formItemLabel}>Электронная почта</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {initialData?.organization_email}
        </div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "9",
      label: <span className={classes.formItemLabel}>ОГРН организации</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {initialData?.organization_ogrn}
        </div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "10",
      label: <span className={classes.formItemLabel}>ИНН организации</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {initialData?.organization_inn}
        </div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "11",
      label: <span className={classes.formItemLabel}>Телефон организации</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>
          {initialData?.organization_phone_number}
        </div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "12",
      name: "postAdress",
      type: "number",
      label: (
        <span className={classes.formItemLabel}>
          Почтовый адрес организации
        </span>
      ),
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>3453453</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
  ];

  const contactInfoFields: IField[] = [
    {
      id: "1",
      name: "surname",
      type: "text",
      label: <span className={classes.formItemLabel}>Фамилия</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.surname}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "2",
      name: "name",
      type: "text",
      label: <span className={classes.formItemLabel}>Имя</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.name}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },

    {
      id: "3",
      name: "patronymic",
      type: "text",
      label: <span className={classes.formItemLabel}>Отчество</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.patronymic}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "4",
      name: "inn",
      type: "number",
      label: <span className={classes.formItemLabel}>ИНН</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.inn}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "5",
      name: "email",
      type: "email",
      label: <span className={classes.formItemLabel}>Электронная почта</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.email}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
    {
      id: "6",
      name: "phone",
      type: "phone",
      label: <span className={classes.formItemLabel}>Телефон</span>,
      children: isEditForm ? (
        <Input size="large" />
      ) : (
        <div className={classes.fieldValue}>{initialData?.phone_number}</div>
      ),
      rules: [],
      className: classes.formItem,
      rootClassName: classes.rootFormItem,
    },
  ];

  return (
    <div className={classes.pageClient}>
      <div className={classes.pageClientButtonBackWrapper}>
        <Button
          onClick={() => navigate(-1)}
          className={classes.pageClientButtonBack}
          icon={
            <ArrowLeftOutlined
              className={classes.pageClientButtonBackIconArrow}
            />
          }
        >
          Назад
        </Button>
      </div>

      <div className={classes.pageClientHeader}>
        <div className={classes.pageClientHeaderTitle}>
          {initialData.organization_name}
        </div>
        {!isEditForm && (
          <div className={classes.pageClientHeaderEditButtonWrapper}>
            <Button
              className={classes.pageClientHeaderEditButton}
              onClick={() => setStateForm(true)}
              iconPosition="end"
              icon={
                <EditOutlined
                  className={classes.pageClientButtonBackIconArrow}
                />
              }
            />
          </div>
        )}
      </div>

      <div className={classes.referralInfoWrapper}>
        <CheckCircleOutlined className={classes.referralInfoIcon} />
        <span className={classes.referralInfoText}>
          Пользователь зарегистрирован по реферальной ссылке
        </span>
      </div>

      <div className={classes.pageClientEIOInfoWrapper}>
        <Divider
          orientation="left"
          orientationMargin="0"
          className={classes.pageClientDivider}
        >
          Информация о ЕИО
        </Divider>

        <div className={classes.pageClientEIOInfoFormWrapper}>
          <Form
            name="eioInfoForm"
            form={eioInfoForm}
            layout="vertical"
            autoComplete="off"
            className={classes.pageClientEIOInfoForm}
          >
            {clientEioInfo.map((el) => {
              return <Form.Item {...el}></Form.Item>;
            })}
          </Form>
        </div>
      </div>

      <div className={classes.pageClientContactInfoWrapper}>
        <Divider
          orientation="left"
          orientationMargin="0"
          className={classes.pageClientDivider}
        >
          Информация о контактном лице
        </Divider>

        <div className={classes.pageClientContactInfoFormWrapper}>
          <Form
            name="contactInfoForm"
            form={contactInfoForm}
            layout="vertical"
            autoComplete="off"
            className={classes.pageClientcontactInfoForm}
          >
            {contactInfoFields.map((el) => {
              return <Form.Item {...el}></Form.Item>;
            })}
            <Form.Item
              name="manager"
              label="Ответственный менеджер"
              rules={[ruleRequired, ruleAddress]}
              key="manager"
              className={classes.lastElementOfFields}
            >
              <Input size="large" disabled={!isEditForm} />
            </Form.Item>
          </Form>
        </div>
      </div>

      <div className={classes.pageClientChangeRoleWrapper}>
        <Divider
          orientation="left"
          orientationMargin="0"
          className={classes.pageClientDivider}
        >
          Смена роли
        </Divider>

        <div className={classes.pageClientchangeRoleFormWrapper}>
          <Button
            onClick={() => setStateForm(true)}
            className={classes.changeRoleButton}
          >
            Отмена
          </Button>
        </div>
      </div>

      {isEditForm && (
        <div className={classes.pageClientActions}>
          <Button
            className={classes.pageClientSaveButton}
            onClick={() => sendDate()}
          >
            Сохранить изменения
          </Button>
          <Button
            className={classes.pageClientCancelButton}
            onClick={() => setStateForm(false)}
          >
            Отмена
          </Button>
        </div>
      )}
    </div>
  );
}
